export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.59eb6b64.png";